export const ORDER = Object.freeze({
  TAKE_OUT: "TakeOut",
  DELIVERY: "Delivery",
});
export const ORDER_NAME: any = Object.freeze({
  TakeOut: "Take Out",
  Delivery: "Delivery",
});
